/**
 * 筹码精灵池（§11.6 60fps 保障第 5 条）。
 *
 * 池化 48 个 DOM 节点复用，**禁止每次下注 createElement**：
 * 一次收池可能同时飞 30+ 个精灵，每次新建/销毁会持续触发样式重算与合成层重建，
 * 中端安卓上直接掉到 30fps。节点常驻、`opacity: 0` 待命，动画期间才可见。
 *
 * 精灵没有 left/top，位置完全由 transform 决定（红线 #46），
 * 所以它们的坐标系原点就是 `.fx-layer` 的左上角 = 舞台左上角。
 */

import { SPRITE_POOL_SIZE } from './motion.js'

/** 精灵视觉直径（px），与 fx.css 的 .chip-sprite 一致 */
export const SPRITE_SIZE = 18

export class ChipSpritePool {
  private readonly all: HTMLElement[] = []
  private readonly free: HTMLElement[] = []

  constructor(layer: HTMLElement, size = SPRITE_POOL_SIZE) {
    const doc = layer.ownerDocument
    for (let i = 0; i < size; i++) {
      const el = doc.createElement('i')
      el.className = 'chip-sprite'
      el.setAttribute('aria-hidden', 'true')
      layer.appendChild(el)
      this.all.push(el)
      this.free.push(el)
    }
  }

  /** 池空时返回 null —— 调用方据此跳过这一个精灵，而不是排队或新建 */
  acquire(): HTMLElement | null {
    return this.free.pop() ?? null
  }

  release(el: HTMLElement): void {
    // 防御：重复 release 会让同一个节点被两次飞行同时持有
    if (this.free.includes(el)) return
    this.free.push(el)
  }

  get available(): number {
    return this.free.length
  }

  destroy(): void {
    for (const el of this.all) el.remove()
    this.all.length = 0
    this.free.length = 0
  }
}
